// For full API documentation, including code examples, visit https://wix.to/94BuAAs

import wixLocation from 'wix-location';
import wixUsers from 'wix-users';

$w.onReady(function () {
	// TODO: write your page related code here...

});

/************** */
/* registration
/************** */

export function registration_click(event) {
	registrationForm("צלילים-מספרים")
}

export function registrationForm(id) {
	let target = decodeURI(id);

	console.log(id + ":" + target);

	let query = wixLocation.query;

	var queryString = Object.keys(query).map((key) => {
		return encodeURIComponent(key) + '=' + encodeURIComponent(query[key])
	}).join('&');

	wixLocation.to(wixLocation.baseUrl + "/registration/" + target + "?" + queryString);
}

/************** */
/* login
/************** */

export function login_click(event) {
	promptLogin("login");
}

export function signup_click(event) {
	promptLogin("signup");
}

function promptLogin(mode) {
	let options = { "mode": mode };

	wixUsers.promptLogin(options)
		// .then((user) => {
		// 	console.log(user);
		// 	wixLocation.to(wixLocation.url);
		// 	// wixWindow.lightbox.close();
		// 	return;
		// })
		.catch((err) => {
			console.log(err); // "The user closed the login dialog"
			wixLocation.to(wixLocation.url);
			return;
		});
}

wixUsers.onLogin( (user) => {
	// console.log(u);
	wixLocation.to(wixLocation.url);
} );

/************** */
/* utils
/************** */

function reverseString(str) {
	return str.split("").reverse().join("");
}